import { createGlobalStyle } from 'styled-components';
import colors from 'themes/Main';

const { gradient, gray06, white } = colors;

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
    font-family: 'Open Sans', sans-serif;
    -webkit-font-smoothing: antialiased;
  }

  html, body, #root {
    min-height: 100%;
    background-color: ${gray06};
    scroll-behavior: smooth;
  }

  body, input, button {
    font-family: 'Open Sans', sans-serif;
    -webkit-font-smoothing: antialiased;
  }

  .activeNavItem {
    background: ${gradient};

    p {
      color: ${white};
    }

    svg > path {
      fill: ${white} !important;
    }
  }

  input[type="time"]::-webkit-inner-spin-button,
  input[type="time"]::-webkit-outer-spin-button {
    -webkit-appearance: none !important;
    -moz-appearance: none !important;
    appearance: none !important;
    margin: 0 !important;
  }

  input[type="time"]::-ms-clear { display: none; }
  input[type="time"]::-webkit-clear-button,
  input[type="time"]::-webkit-datetime-edit-ampm-field {
    display: none !important;
  }

  input::-webkit-inner-spin-button,
  input::-webkit-outer-spin-button {
    -webkit-appearance: none !important;
    -moz-appearance: none !important;
    appearance: none !important;
    margin: 0 !important;
  }
  input::-ms-clear { display: none; }
  input::-webkit-clear-button,
  input::-webkit-datetime-edit-ampm-field {
    display: none !important;
  }
`;

export default GlobalStyle;
